var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./CommonRegions.jinja');
require('./CommonRegions.less');


module.exports = Base.extend({

    template: template,

    events: {
        'mouseenter .CommonRegions-mapRegionBg': 'onMouseEnterRegion',
        'mouseenter .CommonRegions-mapRegionLabel': 'onMouseEnterRegion',
        'mouseleave .CommonRegions-mapRegionBg': 'onMouseLeaveRegion',
        'mouseleave .CommonRegions-mapRegionLabel': 'onMouseLeaveRegion',
        'click .CommonRegions-mapRegionWrapper': 'changeRegion',
        'click .CommonRegions-info': 'onInfoClick',
        'click .CommonRegions-lastUpdatedInfo': 'onLastUpdatedInfoClick'
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'changeRegion', 'onBodyClick');

        Base.prototype.initialize.call(this, options);
    },


    viewsRegistration: function () {

        Base.prototype.viewsRegistration.call(this);
    },


    onInfoClick: function (e) {
        if (app.settings.isDesktop) return;

        if ($(e.target).closest('.CommonRegions-infoPopup').length) return;

        if ($(e.currentTarget).hasClass('CommonRegions-info--active')) {
            this.closeAllInfoPopups();
        } else {
            this.closeAllInfoPopups();
            $(e.currentTarget).addClass('CommonRegions-info--active');
            $('body').on('click', this.onBodyClick);
        }
    },


    onLastUpdatedInfoClick: function (e) {
        if (app.settings.isDesktop) return;

        if ($(e.target).closest('.CommonRegions-lastUpdatedInfoPopup').length) return;

        if ($(e.currentTarget).hasClass('CommonRegions-lastUpdatedInfo--active')) {
            this.closeAllInfoPopups();
        } else {
            this.closeAllInfoPopups();
            $(e.currentTarget).addClass('CommonRegions-lastUpdatedInfo--active');
            $('body').on('click', this.onBodyClick);
        }
    },


    closeAllInfoPopups: function () {
        this.$('.CommonRegions-info').removeClass('CommonRegions-info--active');
        this.$('.CommonRegions-lastUpdatedInfo').removeClass('CommonRegions-lastUpdatedInfo--active');

        $('body').off('click', this.onBodyClick);
    },


    onBodyClick: function (e) {
        if ($(e.target).closest('.CommonRegions-info').length) return;
        if ($(e.target).closest('.CommonRegions-lastUpdatedInfo').length) return;

        this.closeAllInfoPopups();
    },




    onMouseEnterRegion: function (e) {
        var $svg = $(e.target).closest('svg');

        $svg[0].addClass('CommonRegions-mapRegion--hovered');

        clearTimeout($svg.attr('data-timer'));
    },


    onMouseLeaveRegion: function (e) {
        var $svg = $(e.target).closest('svg');

        var timerID = setTimeout(function () {
            $svg[0].removeClass('CommonRegions-mapRegion--hovered');
        }.bind(this), 50);

        $svg.attr('data-timer', timerID);
    },

    changeRegion: function (e) {
        var $region = $(e.currentTarget).closest('svg');
        var $svgActive = $('.CommonRegions-mapRegion--active').closest('svg');

        $svgActive[0].removeClass('CommonRegions-mapRegion--active');

        $region[0].addClass('CommonRegions-mapRegion--active');
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/CommonRegions/CommonRegions.js
// module id = 67
// module chunks = 0